import React from "react";

const FaireContext = React.createContext({
    isFaireConnected: true,
    setIsFaireConnected: () => { },
    isFaireCurrencySet: true,
    setIsFaireCurrencySet: () => { },
    isInventorySettingSet: true,
    setIsInventorySettingSet: () => { },
    isOrderSettingSet: true,
    setIsOrderSettingSet: () => { },
    isCurrencyMatched: true,
    setIsCurrencyMatched: () => { },
    isConversionSet: true,
    setIsConversionSet: () => { },
    isFetching: false,
    setIsFetching: () => { },
});

export default FaireContext;